import {
  WALL_LAYOUT_KEY,
  TEXT_ELEMENT_TYPE,
  METRIC_KEY,
  SQFT_TO_SQMT_CONSTANT,
  WALL_DIRECTION,
  WALLPAPER_CATEGORY,
  POSTER_CATEGORY,
  CUTOUT_CATEGORY,
  CANVAS_CATEGORY
} from '../../utilities/constants/Constants';
import {
  toPlacingJSON,
  Placing,
  copyPlacing,
  toUserPlacingJSON
} from './Placing';
import { toWallJSON, Wall } from './Wall';
import { isSignageSuiteProduct } from '../../utilities/HelperFunctions/HelperFunctions';

export class Project {
  constructor() {
    this.id = null;
    this.externalId = null;
    this.emailAddress = null;
    this.fullName = null;
    this.applicationGroupId = null;
    this.name = '';
    this.customerName = '';
    this.customerEmail = '';
    this.category = null;
    this.height = null;
    this.width = null;
    this.themeId = null;
    this.storeId = null;
    this.hasPixelationWarning = false;
    this.proDesignState = '';
    this.userPlacingsAttributes = {};
    this.externalUserId = null;
    this.xOffset = 0;
    this.yOffset = 0;
    this.unitSystem = 'Metric';
    this.canvasRowsCount = 1;
    this.canvasColumnsCount = 1;
    this.canvasTileType = null;
    this.canvasFrameType = null;
    this.language = 'en';
    this.externalLink = false;
    this.mobileAccess = false;
    this.webLink = false;
    this.externalContent = false;
    this.useOwnContent = false;
    this.includeWallartContent = true;
    this.isMultiwall = false;
    this.templateProject = false;
    this.token = null;
    this.platform = 'desktop';
    this.visualizePlacingsAttributes = {};
    this.targetViewingDistance = null;
    this.projectGroupPosition = 1;
    this.projectGroupId = null;
    this.sharedScene = false;
    this.canvasFrameColor = null;
    this.canvasFrameWidth = null;
    this.isThemeExternal = null;
    this.accountId = null;
    this.materialId = null;
    this.wallIndex = 0;
    this.variableSizeType = 'preset';
    this.placeMsrpCurrency = 'Before price';
    this.isMulticanvas = false;
    this.layoutId = null;
    this.state = 'editing';
    this.backgroundColor = null;
    this.parentId = null;
    this.live = false;
    this.deletableProjectId = null;
    this.projectSizeName = '';
    this.hasPremiumContent = false;
    this.isVanilla = false;
    this.isModified = false;
    this.count = 1;
    this.additionalPrintingInstruction = null;
    this.couponCode = null;
    this.productSizeId = null;
    this.templateDetails = null;
    this.activeWall = null;
    this.posCode = null;
    this.employeeCode = null;
    this.scenePlacings = [];
    this.elementPlacings = [];
    this.removedPlacings = [];
    this.inspirationFilterIds = [];
    this.walls = [];
    this.locked = false;

    this.direction = WALL_DIRECTION.CENTER;
    this.isMultiWall = false;
  }
}

export const copyProject = (project, projectJSON) => {
  project.id = projectJSON.id;
  project.externalId = projectJSON.external_id;
  project.emailAddress = projectJSON.email_address;
  project.fullName = projectJSON.full_name;
  project.applicationGroupId = projectJSON.application_group_id;
  project.name = projectJSON.name;
  project.customerName = projectJSON.customer_name;
  project.customerEmail = projectJSON.customer_email;
  project.category = projectJSON.category;
  project.height = projectJSON.height;
  project.width = projectJSON.width;
  project.themeId = projectJSON.theme_id;
  project.storeId = projectJSON.store_id;
  project.hasPixelationWarning = projectJSON.has_pixelation_warning;
  project.proDesignState = projectJSON.pro_design_state;
  project.userPlacingsAttributes = {};
  project.externalUserId = projectJSON.external_user_id;
  project.xOffset = projectJSON.x_offset;
  project.yOffset = projectJSON.y_offset;
  project.unitSystem = projectJSON.unit_system;
  project.canvasRowsCount = projectJSON.canvas_rows_count;
  project.canvasColumnsCount = projectJSON.canvas_columns_count;
  project.canvasTileType = projectJSON.canvas_tile_type;
  project.canvasFrameType = projectJSON.canvas_frame_type;
  project.language = projectJSON.language;
  project.externalLink = projectJSON.external_link;
  project.mobileAccess = projectJSON.mobile_access;
  project.webLink = projectJSON.web_link;
  project.externalContent = projectJSON.external_content;
  project.useOwnContent = projectJSON.use_own_content;
  project.includeWallartContent = projectJSON.include_wallart_content;
  project.isMultiwall = projectJSON.is_multiwall;
  project.templateProject = projectJSON.template_project;
  project.token = projectJSON.token;
  project.platform = projectJSON.platform;
  project.visualizePlacingsAttributes = {};
  project.targetViewingDistance = projectJSON.target_viewing_distance;
  project.projectGroupPosition = projectJSON.project_group_position;
  project.projectGroupId = projectJSON.project_group_id;
  project.sharedScene = projectJSON.shared_scene;
  project.canvasFrameColor = projectJSON.canvas_frame_color;
  project.canvasFrameWidth = null;
  project.isThemeExternal = null;
  project.accountId = projectJSON.account_id;
  project.materialId = projectJSON.material_id;
  project.wallIndex = projectJSON.wall_index;
  project.variableSizeType = projectJSON.variable_size_type;
  project.placeMsrpCurrency = projectJSON.place_msrp_currency;
  project.isMulticanvas = false;
  project.layoutId = null;
  project.state = projectJSON.state;
  project.backgroundColor = projectJSON.background_color;
  project.parentId = projectJSON.parent_id;
  project.live = false;
  project.inspirationFilterIds = projectJSON.inspiration_filter_ids;
  project.deletableProjectId = projectJSON.deletable_project_id;
  project.projectSizeName = projectJSON.project_size_name;
  project.hasPremiumContent = projectJSON.has_premium_content;
  project.isVanilla = projectJSON.is_vanilla;
  project.isModified = projectJSON.is_modified;
  project.count = projectJSON.count;
  project.additionalPrintingInstruction =
    projectJSON.additional_printing_instruction;
  project.productSizeId = projectJSON.product_size_id;
  project.storeOrderId = projectJSON.store_order_id;
  project.templateDetails = projectJSON.template_details;
  project.gaUid = projectJSON.ga_uid;
  project.posCode = projectJSON.pos_code;
  project.employeeCode = projectJSON.employee_code;
  project.locked = projectJSON.locked;
  initializeWalls(project, projectJSON.walls);
  initializePlacings(project, projectJSON.placings, projectJSON.walls.length);

  const placingsArray = getPlacings(project);
  placingsArray.forEach(placing => {
    const matchedWalls = project.walls.filter(
      wall => wall.id == placing.wallId
    );
    if (matchedWalls.length > 0) {
      placing.wallIndex = matchedWalls[0].index;
    } else {
      placing.wallIndex = 0;
    }
  });
};

export const toProjectJSON = project => {
  const json = {
    id: project.id,
    external_id: project.externalId,
    email_address: project.emailAddress,
    full_name: project.fullName,
    application_group_id: project.applicationGroupId,
    name: project.name,
    customer_name: project.customerName,
    customer_email: project.customerEmail,
    category: project.category,
    height: project.height,
    width: project.width,
    theme_id: project.themeId,
    store_id: project.storeId,
    has_pixelation_warning: project.hasPixelationWarning,
    pro_design_state: project.proDesignState,
    external_user_id: project.externalUserId,
    x_offset: project.xOffset,
    y_offset: project.yOffset,
    unit_system: project.unitSystem,
    canvas_rows_count: project.canvasRowsCount,
    canvas_columns_count: project.canvasColumnsCount,
    canvas_tile_type: project.canvasTileType,
    canvas_frame_type: project.canvasFrameType,
    language: project.language,
    external_link: project.externalLink,
    mobile_access: project.mobileAccess,
    web_link: project.webLink,
    external_content: project.externalContent,
    use_own_content: project.useOwnContent,
    include_wallart_content: project.includeWallartContent,
    is_multiwall: project.isMultiwall,
    template_project: project.templateProject,
    token: project.token,
    platform: project.platform,
    placings_attributes: getPlacingsJSON(project),
    user_placings_attributes: getUserPlacingsJSON(project),
    project_group_position: project.projectGroupPosition,
    project_group_id: project.projectGroupId,
    shared_scene: project.sharedScene,
    canvas_frame_color: project.canvasFrameColor,
    canvas_frame_width: project.canvasFrameWidth,
    is_theme_external: project.isThemeExternal,
    account_id: project.accountId,
    material_id: project.materialId,
    wall_index: project.wallIndex,
    variable_size_type: project.variableSizeType,
    place_msrp_currency: project.placeMsrpCurrency,
    is_multicanvas: project.isMulticanvas,
    layout_id: project.layoutId,
    state: project.state,
    background_color: project.backgroundColor,
    parent_id: project.parentId,
    live: project.live,
    inspiration_filter_ids: project.inspirationFilterIds,
    deletable_project_id: project.deletableProjectId,
    project_size_name: project.projectSizeName,
    has_premium_content: project.hasPremiumContent,
    is_vanilla: project.isVanilla,
    is_modified: project.isModified,
    count: project.count,
    target_viewing_distance: project.targetViewingDistance,
    ga_uid: project.gaUid,
    ga_cid: project.gaUid,
    locked: project.locked
  };
  Object.assign(json, getWallsJSON(project));
  if (isSignageSuiteProduct()) {
    json.visualize_placings_attributes = {};
  }
  if (project.couponCode) {
    json.coupon_code = project.couponCode;
  }
  if (project.productSizeId) {
    json.product_size_id = project.productSizeId;
  }
  if (project.storeOrderId) {
    json.store_order_id = project.storeOrderId;
  }
  if (project.templateDetails) {
    json.template_details = project.templateDetails;
  }
  if (project.posCode) {
    json.pos_code = project.posCode;
  }
  if (project.employeeCode) {
    json.employee_code = project.employeeCode;
  }
  return { project: json };
};

export const getUserPlacingsJSON = project => {
  const userPlacingsJSON = {};
  const placingsArray = getPlacings(project);
  let continueIndex = 0;
  placingsArray.forEach(placing => {
    if (placing.placeableType === TEXT_ELEMENT_TYPE) {
      userPlacingsJSON[continueIndex++] = toUserPlacingJSON(placing);
    }
  });
  project.removedPlacings.forEach(placing => {
    if (placing.placeableType === TEXT_ELEMENT_TYPE) {
      placing.destroy = true;
      userPlacingsJSON[continueIndex++] = toUserPlacingJSON(placing);
    }
  });
  return userPlacingsJSON;
};

export const getPlacingsJSON = project => {
  const placingsJSON = {};
  const placingsArray = getPlacings(project);
  let continueIndex = 0;
  placingsArray.forEach(placing => {
    if (placing.placeableType !== TEXT_ELEMENT_TYPE) {
      placingsJSON[continueIndex++] = toPlacingJSON(placing);
    }
  });

  project.removedPlacings.forEach(placing => {
    if (placing.placeableType !== TEXT_ELEMENT_TYPE) {
      placing.destroy = true;
      placingsJSON[continueIndex++] = toPlacingJSON(placing);
    }
  });
  return placingsJSON;
};

export const getWallsJSON = project => {
  const wallJSON = {};
  if (!isSignageSuiteProduct() && project.walls.length > 0) {
    wallJSON.wall_attributes = toWallJSON(project.walls[0]);
  } else if (project.walls.length > 0) {
    const wallsAttributes = {};
    project.walls.forEach((wall, i) => {
      wallsAttributes[i] = toWallJSON(wall);
    });
    wallJSON.walls_attributes = wallsAttributes;
  }
  return wallJSON;
};

export const getPlacings = project => {
  const placingsArray = [];
  project.scenePlacings.forEach(placing => {
    placingsArray.push(placing);
  });
  project.elementPlacings.forEach(placing => {
    placingsArray.push(placing);
  });
  return placingsArray;
};

export const initializePlacings = (
  modelObject,
  inPlacingsJSON,
  wallsLength
) => {
  if (inPlacingsJSON) {
    const placingsJSON = [...inPlacingsJSON];
    placingsJSON.forEach((placingJSON, placingIndex) => {
      const placing = new Placing();
      copyPlacing(placing, placingJSON);

      if (placing.placeableType == WALL_LAYOUT_KEY) {
        modelObject.placings.push(placing);
      } else if (placingIndex < wallsLength) {
        // While initiating project from reponse placebale details are not fetched. Hence cannot decide whether its  a scene object.
        // Based on placing index and walls length it can be decided since placings will hold scenes first.
        modelObject.scenePlacings.push(placing);
      } else {
        modelObject.elementPlacings.push(placing);
      }
    });
  }
};

export const initializeWalls = (project, wallsJSON) => {
  project.walls = [];
  wallsJSON.forEach((wallJSON, index) => {
    const wall = new Wall(wallJSON);
    wall.index = index;
    initializePlacings(wall, wallJSON.placings, wallsJSON.length);
    project.walls.push(wall);
  });
  project.activeWall = project.walls[project.wallIndex];
};

export const activeScenePlacing = project => {
  const { scenePlacings, activeWall } = project;
  const activeWallScenePlacings = scenePlacings.filter(
    scenePlacing => scenePlacing.wallIndex == activeWall.index
  );
  if (activeWallScenePlacings.length > 0) {
    return activeWallScenePlacings[0];
  }
  return null;
};

export const addScenePlacing = (project, scenePlacing) => {
  const { scenePlacings } = project;
  let oldIndex = -1;
  scenePlacings.forEach((placing, index) => {
    if (placing.wallIndex == scenePlacing.wallIndex) {
      oldIndex = index;
    }
  });
  if (oldIndex >= 0) {
    scenePlacings[oldIndex] = scenePlacing;
  } else {
    scenePlacings.push(scenePlacing);
  }
};

export const pricePerSqft = (
  themesArray,
  materials,
  index,
  unitSystem,
  category,
  isExternalContent
) => {
  if (isMaterialPriceSupported(themesArray, isExternalContent)) {
    if (unitSystem === METRIC_KEY) {
      return materials[index].pricePerSqm;
    }
    return materials[index].pricePerSqft;
  }
  const [defaultTheme] = themesArray;
  let themePricePerSqft = 0;
  if (defaultTheme.yourPrice) {
    if (defaultTheme.yourPrice.perSqftCategory) {
      priceForCurrentCategory(defaultTheme.yourPrice.perSqftCategory, category);
    } else {
      themePricePerSqft = defaultTheme.yourPrice.perSqft;
    }
  } else if (defaultTheme.msrpPrice) {
    if (defaultTheme.msrpPrice.perSqftCategory) {
      priceForCurrentCategory(defaultTheme.msrpPrice.perSqftCategory, category);
    }
    themePricePerSqft = defaultTheme.msrpPrice.perSqft;
  }
  if (unitSystem === METRIC_KEY) {
    return themePricePerSqft / SQFT_TO_SQMT_CONSTANT;
  }
  return themePricePerSqft;
};

export const priceForCurrentCategory = (pricePerSqftCategory, category) => {
  let price = -1;
  switch (category) {
    case CUTOUT_CATEGORY:
      price = pricePerSqftCategory.cutout;
      break;
    case WALLPAPER_CATEGORY:
      price = pricePerSqftCategory.wallcovering;
      break;
    case POSTER_CATEGORY:
      price = pricePerSqftCategory.poster;
      break;
    case CANVAS_CATEGORY:
      price = pricePerSqftCategory.canvas;
      break;
    default:
      price = -1;
      break;
  }
  return price;
};

export const isMaterialPriceSupported = (themesArray, isExternalContent) => {
  const isUseMaterialPrice =
    themesArray.filter(theme => theme.useMaterial).length > 0;
  return !isExternalContent || (isExternalContent && isUseMaterialPrice);
};
